// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --uni_std_clr: rgba(0, 102, 204, 1);
  --grey_tone: rgba(131, 143, 180, 1);
  --text_darkGrey: rgba(77, 77, 77, 1);
  --card_border: rgba(191, 215, 251, 1);
  --background_blue: rgba(0, 102, 204, 0.1);
  --border_color: rgba(0, 102, 204, 0.5);
  --red-color: rgba(255, 84, 79, 1);
  --border-color-grey: rgba(228, 228, 228, 1);
  --description_grey: rgba(169, 172, 180, 1);
  --description_2: rgba(83, 83, 83, 1);
  --analytics_grey: rgba(163, 174, 208, 0.5);
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.timelineTable .btn.show{
  background: #0d6efd !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,oCAAoC;EACpC,qCAAqC;EACrC,yCAAyC;EACzC,sCAAsC;EACtC,iCAAiC;EACjC,2CAA2C;EAC3C,0CAA0C;EAC1C,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT;wEACsE;EACtE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":[":root {\n  --uni_std_clr: rgba(0, 102, 204, 1);\n  --grey_tone: rgba(131, 143, 180, 1);\n  --text_darkGrey: rgba(77, 77, 77, 1);\n  --card_border: rgba(191, 215, 251, 1);\n  --background_blue: rgba(0, 102, 204, 0.1);\n  --border_color: rgba(0, 102, 204, 0.5);\n  --red-color: rgba(255, 84, 79, 1);\n  --border-color-grey: rgba(228, 228, 228, 1);\n  --description_grey: rgba(169, 172, 180, 1);\n  --description_2: rgba(83, 83, 83, 1);\n  --analytics_grey: rgba(163, 174, 208, 0.5);\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',\n    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.timelineTable .btn.show{\n  background: #0d6efd !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
